export const BANNER_LOAD_REQUEST = 'BANNER_LOAD_REQUEST';
export const BANNER_LOAD_SUCCESS = 'BANNER_LOAD_SUCCESS';
export const BANNER_LOAD_FAILURE = 'BANNER_LOAD_FAILURE';
export const BANNER_DISMISSAL_POST = 'BANNER_DISMISSAL_POST';
